<template>
  <div>
    <!--begin::prontuario-->

    <div class="mb-6">
      <!--begin::Dashboard-->
      <div class="row">
        <div style="background-color: rgb(29, 209, 161)" class="col-md-12">
          <h3 style="float: left" class="textTitile mt-4 mb-4">
            Histórico de Hábitos de vida
          </h3>
        </div>
        <div class="col-md-12 mt-4">
          <v-toolbar style="height: 6rem; display: none">
            <v-toolbar-title
              ><v-btn
                @click="consultaHistoriaPatologica"
                color="#1dd1a1"
                class="mr-4 mb-2 mt-6"
              >
                <v-icon center small color="#FFF">fas fa-search</v-icon></v-btn
              ></v-toolbar-title
            >

            <v-text-field
              @keyup.enter.native="consultaHistoriaPatologica"
              v-model="consulta"
              class="mt-14"
              label="Pesquise consultas por Data, CPF, especialidade"
              color="green"
              filled
              solo-inverted
            ></v-text-field>
          </v-toolbar>

          <div class="row mt-6">
            <div
              style="
                display: flex;
                align-itens: center;
                justify-content: space-between;
              "
              class="col-md-12"
            >
              <b-tooltip :target="`tooltip3-target`" triggers="hover">
                Página anterior
              </b-tooltip>
              <b-tooltip :target="`tooltip4-target`" triggers="hover">
                Próxima página
              </b-tooltip>
              <div class="mt-2">
                <h3>Página {{ this.page }} de {{ this.totalPages }}</h3>
              </div>
              <div>
                <v-btn
                  :disabled="this.page == 0 || this.page == 1 ? true : false"
                  @click="anteriorPage"
                  id="tooltip3-target"
                  color="#1dd1a1"
                  class="mr-1"
                >
                  <v-icon center small color="#FFF"
                    >fas fa-arrow-left</v-icon
                  ></v-btn
                >
                <v-btn
                  :disabled="
                    this.page == this.totalPages || this.totalPages == 0
                      ? true
                      : false
                  "
                  @click="proximoPage"
                  id="tooltip4-target"
                  color="#1dd1a1"
                >
                  <v-icon center small color="#FFF"
                    >fas fa-arrow-right</v-icon
                  ></v-btn
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <v-simple-table fixed-header>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="">Descrição da história</th>
                  <th class=""></th>
                  <th class=""></th>
                  <th class=""></th>
                </tr>
              </thead>

              <tbody v-for="historia in tempHistorias" :key="historia.id">
                <tr>
                  <td colspan="4">
                    {{ historia.historia }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <div
            v-if="historia == 0"
            class="d-flex flex-column-fluid flex-center mt-12"
          >
            <a href="#" class="text-center mb-10">
              <img
                src="media/novaImagens/logo.png"
                class="max-h-200px"
                alt=""
              />
            </a>
          </div>
        </div>
      </div>

      <!--end::Dashboard-->
    </div>

    <div class="row">
      <div class="col-md-12">
        <!--begin::prontuario-->
        <div class="row">
          <div class="col-md-12">
            <div
              style="
                background-color: rgb(29, 209, 161);
                height: 3.8rem;
                padding: 0.5px;
              "
              class="col-md-12"
            >
              <h3 style="float: left" class="textTitile mt-4 ml-4">
                Dados de História de hábitos de vida
              </h3>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-md-12">
            <validation-observer
              class="mt-6"
              ref="observer"
              v-slot="{ invalid }"
            >
              <form @submit.prevent="cadastrarHistoricoFamiliar">
                <div class="row">
                  <div class="col-md-12">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Descrição"
                      rules="required"
                    >
                      <b-form-textarea
                        :error-messages="errors"
                        v-model="descricaoHistoria"
                        placeholder="Digite a descrição da História"
                        rows="3"
                        required
                        max-rows="6"
                      ></b-form-textarea>
                    </validation-provider>
                  </div>
                </div>

                <div class="row mb-4">
                  <div class="col-md-12">
                    <v-btn
                      v-if="dados.dados_prontuario.habito_existe == false"
                      @click="cadastrarHistoricoFamiliar"
                      style="float: right"
                      :disabled="invalid"
                      class="mt-4 textStyle"
                      tile
                      color="#1dd1a1"
                    >
                      <span style="color: white">Salvar</span>
                    </v-btn>

                    <v-btn
                      v-else
                      @click="atualizarHistoricoFamiliar"
                      style="float: right"
                      :disabled="invalid"
                      class="mt-4 textStyle"
                      tile
                      color="#1dd1a1"
                    >
                      <span style="color: white">Salvar</span>
                    </v-btn>
                  </div>
                </div>
              </form>
            </validation-observer>
          </div>
        </div>
        <!--end::prontuario-->
      </div>
    </div>

    <!--end::prontuario-->
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import * as ambulatorio from "../../../../core/services/ambulatorioAPI.service";
import { required } from "vee-validate/dist/rules";

import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";

setInteractionMode("eager");

extend("required", {
  ...required,
  message: "O campo {_field_} precisa ser preenchido",
});

export default {
  name: "prontuario",
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    dados: Object,
  },
  async created() {
    try {
      const { data: data2 } = await ambulatorio.showProntuarioHistoriaHabitos(
        this.dados.dados_prontuario.id
      );

      this.idHistoricoHabito = data2.habito.id;

      const { data } = await ambulatorio.listaHistoricoHabitos(
        this.dados.dados_prontuario.id,
        1
      );

      this.totalPages = data.total_pages;
      this.historias = data.historico_habito;
      this.tempHistorias = data.historico_habito;
    } catch (error) {
      console.log(error.message);
    }
  },

  data() {
    return {
      idHistoricoHabito: "",
      descricaoHistoria: "",
      consulta: "",
      historias: [],
      tempHistorias: [],
      totalPages: 0,
      page: 1,

      paciente_id: "",
    };
  },

  methods: {
    atualizarHistoricoFamiliar: async function () {
      try {
        const data = {
          habito: {
            historia: this.descricaoHistoria,
          },
        };

        await ambulatorio.atualizarHistoricoHabitos(
          this.idHistoricoHabito,
          data
        );

        Swal.fire({
          title: "",
          text: "Cadastro realizado com sucesso",
          icon: "success",
          confirmButtonColor: "green",
          heightAuto: false,
        });

        this.descricaoHistoria = "";

        const { data: data2 } = await ambulatorio.listaHistoricoHabitos(
          this.dados.dados_prontuario.id,
          1
        );

        this.totalPages = data2.total_pages;
        this.historias = data2.historico_habito;
        this.tempHistorias = data2.historico_habito;
      } catch (error) {
        console.log(error);

        Swal.fire({
          title: "",
          text: "Erro ao realizar cadastro, verifique as informações",
          icon: "error",
          confirmButtonColor: "red",
          heightAuto: false,
        });
      }
    },
    cadastrarHistoricoFamiliar: async function () {
      try {
        const data = {
          habito: {
            historia: this.descricaoHistoria,
            prontuario_id: this.dados.dados_prontuario.id,
          },
        };

        await ambulatorio.regiterHistoricoHabitos(data);

        Swal.fire({
          title: "",
          text: "Cadastro realizado com sucesso",
          icon: "success",
          confirmButtonColor: "green",
          heightAuto: false,
        });

        const { data: data2 } = await ambulatorio.listaHistoricoHabitos(
          this.dados.dados_prontuario.id,
          1
        );

        this.totalPages = data2.total_pages;
        this.historias = data2.historico_habito;
        this.tempHistorias = data2.historico_habito;

        const { data: data3 } = await ambulatorio.showProntuarioHistoriaHabitos(
          this.dados.dados_prontuario.id
        );

        this.idHistoricoHabito = data3.habito.id;

        this.descricaoHistoria = "";

        this.dados.dados_prontuario.habito_existe = true;
      } catch (error) {
        console.log(error);
        Swal.fire({
          title: "",
          text: "Erro ao realizar cadastro, verifique as informações",
          icon: "error",
          confirmButtonColor: "red",
          heightAuto: false,
        });
      }
    },
    consultaHistoriaPatologica: async function () {},
    proximoPage: async function () {
      try {
        this.page++;
        if (this.page <= this.totalPages) {
          const { data } = await ambulatorio.listaHistoricoHabitos(
            this.dados.dados_prontuario.id,
            this.page
          );
          this.totalPages = data.total_pages;
          this.historias = data.historico_habito;
          this.tempHistorias = data.historico_habito;
        } else {
          this.page--;
        }
      } catch (error) {
        console.log(error);
      }
    },
    anteriorPage: async function () {
      try {
        this.page--;
        if (this.page >= 1) {
          const { data } = await ambulatorio.listaHistoricoHabitos(
            this.dados.dados_prontuario.id,
            this.page
          );
          this.totalPages = data.total_pages;
          this.historias = data.historico_habito;
          this.tempHistorias = data.historico_habito;
        } else {
          this.page++;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Prontuário" }]);
  },
};
</script>

<style>
.nav-link.active {
  color: rgb(29, 209, 161) !important;
  font-size: 1.1em;
}

.nav-link:hover {
  color: rgb(29, 209, 161) !important;
}

.bg-success {
  background-color: rgb(29, 209, 161) !important;
}

.textTitile {
  color: white;
  text-align: center;
}
</style>
